import { useContext } from 'react';
import { Space, Tooltip } from 'antd';
import ButtonIcon from 'components/buttonIcon';
import { SessionContext } from 'contexts/session';
import { reportStatus } from 'contexts/reporting/utils';
import { onDownloadReport } from 'pages/Reporting/components/shared/utils';
import { IReport } from 'contexts/reporting/types';

const ButtonsCell = ({
  report,
  loading,
  onDeleteReport,
}: {
  report: IReport;
  loading: boolean;
  onDeleteReport: (id: string, name: string) => void;
}): JSX.Element => {
  const { user } = useContext(SessionContext);
  const isCreatedByUser = report.created_by.uaa_id === user.uaa_id;

  return (
    <Space>
      <ButtonIcon
        icon="Download"
        size="small"
        $secondary
        disabled={report.status !== reportStatus.completed || loading}
        onClick={() => onDownloadReport(report.id)}
      />
      <Tooltip
        title={isCreatedByUser ? 'Remove report' : 'You can only delete reports you created.'}
        placement="bottomLeft"
      >
        <div>
          <ButtonIcon
            icon="Trash"
            size="small"
            $secondary
            disabled={!isCreatedByUser || loading}
            onClick={() => onDeleteReport(report.id, report.name)}
          />
        </div>
      </Tooltip>
    </Space>
  );
};

export default ButtonsCell;
